import { errorCodes, lessonResultCode, ACCOUNT_TYPE } from '@/utils/constants';
import mbti from './mbti';

export default {
  messages: {
    ...mbti,
    leaveMyStageConfirmation: {
      dialogTitle: {
        [ACCOUNT_TYPE.trainer]: 'MyStageのレッスンルームを退出しますか？',
        [ACCOUNT_TYPE.student]: 'このルームを退室しますか？'
      },
      beforeLessonStart: 'レッスン開始時間の「{0}」<br/>までに再度入室ください。',
      duringLessonTime: '終了時間「{0}」までは、<br/>再度トレーナーと接続が可能です。',
      duringGracePeriod: {
        [ACCOUNT_TYPE.trainer] : '今退出すると、受講生と再接続できなくなります。',
        [ACCOUNT_TYPE.student] : 'レッスン終了時間のため、トレーナーとの接続は出来なくなります。'
      },
      afterGracePeriod: {
        [ACCOUNT_TYPE.trainer]: 'このレッスンのPEDAを提出するまでは、いつでもこのページに戻ることができます。',
        [ACCOUNT_TYPE.student]: 'レッスンフィードバックが登録されるとこちらのルームには入室できません。',
      },
      controls: {
        leave: '退室する',
        confirm: '退室する',
        cancel: 'レッスンページに戻る'
      },
      testCallLeave: 'テストレッスンを終了するにはタブを閉じて下さい。'
    },
    leaveMyStageChatHistory: {
      dialogTitle: 'チャット履歴を閉じますか？',
      controls: {
        leave: '閉じる',
        confirm: '閉じる',
        cancel: 'キャンセル'
      }
    },
    lessonTimer: {
      lessonDateTimeLabel: 'レッスン日時',
      lessonDateFormat: 'YYYY年MM月DD日',
      beforeLessonStart: 'レッスン開始時刻',
      lessonHasEnded: 'レッスンは終了しました',
      timerLabel: '残り時間',
      nextLessonMessage: '次のクラスは2分後に開始します。現在のレッスンをまとめ、MyStageのレッスンルームを正しく退出し、次のクラスに間に合うようにしてください。'
    },
    videoMessage: {
      waitingForLesson: 'レッスン開始までお待ちください。',
      connectionProblem: '接続中に問題が発生しました。ページを更新してください。',
      waitingForOtherParty: {
        [ACCOUNT_TYPE.trainer] : '受講生が入室するまでお待ちください。',
        [ACCOUNT_TYPE.student] : 'トレーナーが入室するまでお待ちください。'
      },
      simultaneousConnection:
        '他のデバイスから接続されましたため、本デバイスでのビデオが断続されました',
      lessonEnded: 'レッスンは終了しました',
      streamError: {
        unexpectedError: '<h2>予期しないエラーが発生しました。</h2> ページを更新してください。',
        deviceInvalid: '<h2>予期しないエラーが発生しました。</h2> ページを更新してください。'
      },
      noInternetConnection:
        'インターネット接続が確認できませんでした。<br>インターネット環境を確認ください。',
      onlineStatus: {
        [ACCOUNT_TYPE.trainer] : '受講生がレッスンルームに入室しました。レッスンが開始されるまでお待ちください。',
        [ACCOUNT_TYPE.student] : 'トレーナーはレッスンルームに入室しています。レッスン開始までしばらくお待ちください。'
      },
      reconnecting: '「再接続中...',
      reconnectingSubtext1: 'ただいま通信状況を確認しています。',
      reconnectingSubtext2: 'このまま画面を閉じずにお待ちください。」'
    },
    deviceErrorGuide: {
      tooltip: 'Show more info',
      camera: 'カメラ',
      mic: 'マイク',
      title: {
        notFound: '{device}を使用できません',
        permissionDenied: '{device}の許可が必要です'
      },
      permissionDenied: {
        chrome:
          '<ol><li>ブラウザのアドレスバーの左にあるチューニングアイコンをクリックします</li>' +
          '<li>{device}へのアクセスを許可します</li>' +
          '<li>ページを再読み込みします</li></ol>',
        edge:
          '<ol><li>ブラウザのアドレスバーの左にあるチューニングアイコンをクリックします</li>' +
          '<li>{device}へのアクセスを許可します</li>' +
          '<li>ページを再読み込みします</li></ol>',
        firefox:
          '<ol><li>ブラウザのアドレスバーにある設定アイコンをクリックします</li>' +
          '<li>{device}へのアクセスをブロック解除します</ol>',
        safari:
          '<ul><li>MyStage ページを再読み込みして{device}を許可します' +
          '<li>Safari > 設定 > ウェブサイトに移動し、このサイトが{device}にアクセスできることを確認します</ul>',
        chromeMacOS:
          '<ol><li>ブラウザのアドレスバーの左にあるチューニングアイコンをクリックします</li>' +
          '<li>{device}へのアクセスを許可します</li>' +
          '<li>ページを再読み込みします</li>' +
          '<li>Apple メニュー  ->  システム設定でカメラアクセスが有効になっていることを確認します</li></ol>'
      },
      notFound:
        '<ul><li>{device}を使用している可能性のある他のアプリケーションを閉じます</li>' +
        '<li>{device}が正しく接続され、インストールされていることを確認します</li>' +
        '<li>ブラウザを再起動します</li>' +
        '<li>問題が解決しない場合は、ブラウザ固有の問題を排除するために別のブラウザを試してください</li></ul>',
      notFoundMacOS:
        '<ul><li>{device}を使用している可能性のある他のアプリケーションを閉じます</li>' +
        '<li>{device}が正しく接続され、インストールされていることを確認します</li>' +
        '<li>ブラウザを再起動します</li>' +
        '<li>問題が解決しない場合は、ブラウザ固有の問題を排除するために別のブラウザを試してください</li>' +
        '<li>Apple メニュー  ->  システム設定でカメラアクセスが有効になっていることを確認します</li></ul>'
    },
    chatBox: {
      downloadChatCsv: 'CSVダウンロード',
      printChat: '印刷する',
      deleteLabel: '削除する',
      deletedMessage: 'このメッセージは削除されました。',
      editLabel: '編集する'
    },
    usefulPhrases: {
      buttonLabel: '入力'
    },
    buttons: {
      share: '画面共有',
      reload: '再接続',
      record: '録画',
      recording: '録画'
    },
    discoveryMaterial: {
      level: 'レベル'
    },
    vocabulary: {
      list: {
        title: '単語帳',
        showAll: 'すべて表示',
        close: '閉じる',
        edit: '編集',
        instructions: {
          title: 'My単語帳の使い方',
          subtitle: '現在、このレッスンのMy単語帳に保存されている単語はありません。',
          step1: 'テキスト上の単語をクリックすると、単語の意味がわかります。（上図）',
          step2: '「保存する」をクリックすると、レッスン別のMy単語帳に保存できます。',
          step3:
            '保存した単語は、レッスン中にメモを残したり、My単語帳でテストを受けることができます。',
          step4: '保存した単語は、単語リストに表示され、レッスン中も確認することができます。'
        }
      },
      tooltip: {
        saveLabel: 'この単語を保存',
        savedLabel: '保存しました',
        saved: '保存済み',
        noMeaning: 'この単語のデータがないため表示できません。',
        pronounciation: '発音記号',
        inflection: '語形変化'
      },
      folderList: {
        title: 'ドラッグ＆ドロップで 単語を分類できます',
        edit: '名前の変更',
        delete: '削除',
        add: 'リストを追加'
      },
      modalList: {
        editTitle: '単語の編集',
        selectedWordCount: '件を選択中',
        dragWordCount: '件の単語を選択中',
        disabledDragWordCount: '上限数（999件）に達している単語リストには移動できません',
        move: 'リスト移動',
        edit: '編集',
        delete: '削除',
        selectAll: 'すべて選択'
      },
      pagination: {
        label: '表示件数',
        prev: '前へ',
        next: '次へ'
      },
      folderDelete: {
        return: '戻る',
        note: '注意',
        instructions:
          '削除を実行すると元には戻せません。<br> {0}を削除すると、リスト内の単語も全て削除されます。<br> 本当によろしいですか？',
        cancel: 'キャンセル',
        delete: '削除を実行',
        wordsToDelete: '削除する単語リスト',
        wordsList: '削除する単語一覧'
      },
      confirmation: {
        done: '完了',
        listDeleted: '{0}件の単語リストの<br>削除を完了しました。',
        listAndWordsDeleted: '{0}件の単語リスト、{1}件の単語の<br>削除を完了しました。',
        wordsDeleted: '{0}件の単語の<br>削除を完了しました。',
        returnToEdit: '編集画面に戻る'
      },
      modalFolderList: {
        return: '戻る',
        title: '単語リストの編集',
        rename: '名前を変更',
        createNew: '新規作成',
        delete: '削除',
        cancel: 'キャンセル',
        editComplete: '編集を完了',
        cannotEdit: 'この単語リストは編集できません',
        createNewList: '新規リスト作成',
        addList: 'リストを追加'
      },
      translationListEdit: {
        title: '単語の編集',
        selected: '{0}件を選択中',
        cancel: 'キャンセル',
        edit: '編集を完了'
      },
      moveWord: {
        selected: '{0}件の単語を移動します。',
        text: '移動先の単語リストを選択してください。',
        button: 'リスト移動'
      },
      manualTranslation: {
        newWord: '新しい言葉',
        return: '戻る',
        translate: '翻訳する',
        word: '語',
        translation: '翻訳',
        cancel: 'キャンセル',
        save: 'セーブ',
        successMsg: 'Successfully created.',
        errorMsg: 'There was an error creating entry translation.',
        duplicateMsg: '{0} already exist.'
      },
      noteUpdated: 'メモを更新しました'
    },
    vocabularyManagement: {
      headerTitle: 'Vocabulary Management',
      create: '+ Add New',
      update: 'Edit',
      list: {
        columns: {
          word: 'Word',
          translation: 'Translation',
          typeOfWord: 'Type of Word',
          exampleSentence: 'Example Sentence',
          option: 'Action'
        },
        noData: 'No Vocabulary Data'
      },
      options: {
        createTitle: 'Add New Vocabulary',
        updateTitle: 'Edit Vocabulary',
        updateMsg: 'Translation successfully updated',
        createMsg: 'Translation successfully created'
      }
    },
    materialControls: {
      previous: '前の教材',
      next: '次の教材',
      change: '教材変更',
      myWordBook: 'My単語帳'
    },
    vocabularyBook: {
      title: '単語帳',
      noWordTitle: 'My単語帳',
      update: '決定',
      cancel: 'キャンセル'
    },
    lessonResult: {
      unknown: 'レッスン中に問題が発生しました',
      [lessonResultCode.TRAINER_REQUESTS_SKYPE]:
        'トレーナー側にシステムトラブルが発生したため、レッスンが中止されました。',
      [lessonResultCode.STUDENT_NOSHOW]: '事前のご連絡が無く、欠席となりました。',
      [lessonResultCode.STUDENT_ABSENT]:
        '「欠席する」が押下されたため、レッスンがキャンセルされました。',
      [lessonResultCode.STUDENT_CANCEL]:
        '「レッスンをキャンセルする」が押下されたため、レッスンがキャンセルされました。',
      [lessonResultCode.TRAINER_SUBSTITUTION]:
        '本レッスンは代替トレーナー {0}にて実施します。レッスン開始時間までしばらくお待ちください。',
      [lessonResultCode.ADMIN_CANCEL]: '問題が発生しているため、レッスンがキャンセルされました。',
      [lessonResultCode.STUDENT_EMERGENCY]:
        '「問題を通報する」が押下されたため、レッスンが中止されました。',
      [lessonResultCode.ADMIN_EMERGENCY]: '問題が発生しているため、レッスンが中止されました。',
      [lessonResultCode.PENDING_EMERGENCY]: '「問題を通報する」が押下されたため、レッスンが中止されました。'
    },
    recordingUnavailable: '現在Safariでは<br>レッスンルームの録画・録音<br>は出来ません。',
    vBackgroundUnavailable: '現在Safariでは、背景変更機能は<br>ご利用いただけません。',
    chatUnavailable: 'チャットは一時的に利用できません',
    messageDisclaimer: 'レッスン開始時刻になると、メッセージが送信できるようになります。',
    endNote: {
      [ACCOUNT_TYPE.student] : 'レッスン終了時刻から一定時間経過したため、これ以降メッセージは送れません。',
      [ACCOUNT_TYPE.trainer] : 'レッスン終了時刻から一定時間経過したため、これ以降メッセージは送れません。'
    },
    lessonEndNote: 'レッスン時間が終了したため、メッセージの送信はできません。',
    chatEvents: {
      11: {
        remote: '{0}がレッスンルームに入室しました',
        local: 'レッスンルームに入室しました'
      },
      12: {
        remote: '{0}がレッスンルームを退室しました',
        local: 'レッスンルームを退室しました'
      },
      21: {
        remote: '{0}のビデオとオーディオへの接続が回復しました',
        local: '{0}さんのビデオとオーディオへの接続が回復しました'
      },
      22: {
        remote: '{0}のビデオとオーディオへの接続が切断されました',
        local: '{0}さんのビデオとオーディオへの接続が切断されました'
      }
    },
    exitMessage: {
      unknown: '問題（{re}）が発生しているため、再入室は出来ません。',
      [lessonResultCode.TRAINER_REQUESTS_SKYPE]:
        'トレーナー側にシステムトラブルが発生したため、レッスンが中止されました。',
      [lessonResultCode.PENDING_EMERGENCY]:
        '「問題を通報する」が押下されたため、レッスンが中止されました。',
      [lessonResultCode.STUDENT_NOSHOW]: '事前のご連絡が無く、欠席となりました。',
      [lessonResultCode.STUDENT_ABSENT]: '「欠席する」が押下されたため、再入室は出来ません。',
      [lessonResultCode.STUDENT_CANCEL]:
        '「レッスンをキャンセルする」が押下されたため、再入室は出来ません。',
      [lessonResultCode.ADMIN_CANCEL]: '問題が発生しているため、再入室は出来ません。',
      [lessonResultCode.STUDENT_EMERGENCY]:
        '「問題を通報する」が押下されたため、再入室は出来ません。',
      [lessonResultCode.ADMIN_EMERGENCY]: '問題が発生しているため、再入室は出来ません。'
    },
    errorView: {
      generalMsg:
        '1. Close MyStage <br>2. Log out of the Bizmates portal <br>3. Log back in <br>4. Open MyStage again',
      generalTitle: 'An error has occurred.',
      nbfMsg:
        'ご利用のデバイスの時間を認知することが出来ませんでした。<br>ご利用デバイスの時刻設定がブラウザと連動しているかをご確認ください。'
    },
    errors: {
      general: {
        message: '<a href="{0}">こちらをクリックするとホーム画面に移動します。/ Click Here to go to the Home Screen.</a>'
      },
      [errorCodes.ME001]: {
        message: 'レッスンルームへの入室時にエラーが発生しました。<br><br>' +
        '恐れ入りますが、ご利用の端末の設定時刻がご利用されている地域（タイムゾーン）の時刻よりも遅れている可能性があります。<br>' +
        'ご利用端末の時刻設定を調整頂き再度レッスンルームへ入室してください。<br><br>' +
        '時刻設定の方法は、<a href="https://supportbot-admin.userlocal.jp/pages/cfedf72a8faaa713c095?q=MyStageでレッスンを受講する際にデバイスの時刻を調整する必要がありますか" alt="時刻設定の方法">こちら</a>　をご参照ください<br><br>' +
        'もし同じエラーが発生した場合は、ホーム画面の「予約状況」に表示されている「レッスンに問題があった場合」より<br>' +
        '「問題を通報する」をご選択ください。<br><br>' +
        'それにより当日中に再予約が可能となります。もし当日に再予約をされなかった場合は、翌日以降にご利用いただけるレッスンチケットを1枚お送りいたします。<br><br><br>' +
        'An error occurred when entering the lesson room.<br><br>' +
        'We apologize for the inconvenience, but the time set on your device may be behind the time in your region (time zone).<br>' +
        'Please adjust the time settings on your device and re-enter the lesson room.',
      },
      [errorCodes.ME002]: {
        message: 'レッスンルームへの入室時にエラーが発生しました。<br><br>' +
        '恐れ入りますが、以下の「こちら」をクリックし、ホーム画面にてMyBizmatesを一度ログアウトして再度ログインした上でレッスンルームへ入室してください。<br><br>' +
        'もし同じエラーが発生した場合は、ホーム画面の「予約状況」に表示されている「レッスンに問題があった場合」より<br>' +
        '「問題を通報する」をご選択ください。<br><br>' +
        'それにより当日中に再予約が可能となります。もし当日に再予約をされなかった場合は、翌日以降にご利用いただけるレッスンチケットを1枚お送りいたします。<br><br><br>' +
        'An error occurred when entering the lesson room.<br><br>' +
        'Please click the link below to log out of MyBizmates on the home screen and log in again to re-enter the lesson room.',
      },
      [errorCodes.ME003]: {
        message: 'レッスンルームへの入室時にエラーが発生しました。<br><br>' +
        '恐れ入りますが、以下の「こちら」をクリックし、ホーム画面にてMyBizmatesを一度ログアウトして再度ログインした上でレッスンルームへ入室してください。<br><br>' +
        'もし同じエラーが発生した場合は、ホーム画面の「予約状況」に表示されている「レッスンに問題があった場合」より<br>' +
        '「問題を通報する」をご選択ください。<br><br>' +
        'それにより当日中に再予約が可能となります。もし当日に再予約をされなかった場合は、翌日以降にご利用いただけるレッスンチケットを1枚お送りいたします。<br><br><br>' +
        'An error occurred when entering the lesson room.<br><br>' +
        'Please click the link below to log out of MyBizmates on the home screen and log in again to re-enter the lesson room.',
      },
      [errorCodes.ME004]: {
        message: 'レッスンルームへの入室時にエラーが発生しました。<br><br>' +
        '恐れ入りますが、以下の「こちら」をクリックし、ホーム画面にてMyBizmatesを一度ログアウトして再度ログインした上でレッスンルームへ入室してください。<br><br>' +
        'もし同じエラーが発生した場合は、ホーム画面の「予約状況」に表示されている「レッスンに問題があった場合」より<br>' +
        '「問題を通報する」をご選択ください。<br><br>' +
        'それにより当日中に再予約が可能となります。もし当日に再予約をされなかった場合は、翌日以降にご利用いただけるレッスンチケットを1枚お送りいたします。<br><br><br>' +
        'An error occurred when entering the lesson room.<br><br>' +
        'Please click the link below to log out of MyBizmates on the home screen and log in again to re-enter the lesson room.',
      },
      [errorCodes.ME005]: {
        message: 'レッスンルームへの入室時にエラーが発生しました。<br><br>' +
        '恐れ入りますが、以下の「こちら」をクリックし、ホーム画面にてMyBizmatesを一度ログアウトして再度ログインした上でレッスンルームへ入室してください。<br><br>' +
        'もし同じエラーが発生した場合は、ホーム画面の「予約状況」に表示されている「レッスンに問題があった場合」より<br>' +
        '「問題を通報する」をご選択ください。<br><br>' +
        'それにより当日中に再予約が可能となります。もし当日に再予約をされなかった場合は、翌日以降にご利用いただけるレッスンチケットを1枚お送りいたします。<br><br><br>' +
        'An error occurred when entering the lesson room.<br><br>' +
        'Please click the link below to log out of MyBizmates on the home screen and log in again to re-enter the lesson room.',
      },
    },
    browserNotSupported: {
      title: '申し訳ございません。<br/>今お使いのブラウザではご利用できません。',
      description_old:
        'MyStageでは最新バージョンのブラウザでの<span class="mobile_line_break">ご利用をお願いしております。</span><br/>ブラウザのバージョンアップをいただくか、以下の推奨ブラウザへご変更ください。',
      description:
        '下記ブラウザをお使いの方は最新版を<span class="mobile_line_break">ダウンロードしてください。</span><br/>その他のブラウザをお使いの方は、<span class="mobile_line_break">ブラウザを選んでダウンロードしてください。</span>',
      recommended: '利用可能ブラウザ',
      version: '最新バージョン',
      close: '閉じる'
    },
    deviceCheck: {
      title: 'さあレッスンをはじめよう。',
      subtitle:
        'カメラ・マイク・スピーカーが正しく設定されているか<br/>確認してからレッスンを開始してください。',
      enter: 'MyStageに入室する',
      speakerTest: 'テスト',
      deviceError: 'デバイスはみつかりません。',
      selectDevice: 'デバイスを選択',
      bottomErrorMessage: '各ブラウザの設定からデバイスの使用を許可してください。',
      footerNotes: 'レッスンが上手く始まらない場合は、 こちらから対処法をご確認ください。',
      selectCamera: 'カメラを選択',
      selectMicrophone: 'マイクを選択',
      selectSpeaker: 'Select speaker',
      connectingCamera: 'カメラを接続中です。'
    },
    chatNotification: '新着メッセージ',
    networkAlert: 'インターネット接続が不安定です',
    networkAudioOnlyAlert: 'この動画はインターネット接続が不安定なため一時停止されています。',
    triallesson: {
      exit: '退出',
      list: {
        pageExpires: '本ページ有効期限',
        columns: {
          userAUrl: 'ユーザーAのURL',
          userBUrl: 'ユーザーBのURL',
          from: '開始時刻',
          to: '終了時刻'
        },
        generate: '作成',
        noData: '利用可能なデータがありません。',
        urlCopied: 'URLをクリップボードにコピーしました。',
        urlCopyError: 'URLのコピーに何か問題が発生しました。手動でURLをコピーしてください。'
      },
      login: {
        validation: {
          emptyEmail: 'メールアドレスを入力してください。',
          validEmail: '有効なメールアドレスを入力してください。',
          emptyPassword: 'パスワードを入力してください。',
          validPassword: 'パスワードが正しくありません。',
          notValid: 'メールアドレスまたはパスワードが正しくありません。'
        },
        form: {
          email: 'Eメールアドレス',
          password: 'パスワード',
          login: 'ログイン'
        }
      },
      logout: {
        title: 'ログアウト',
        message: 'ログインしてよろしいですか？',
        cancel: 'キャンセル'
      },
      warnings: {
        notLoggedIn: '...にログインしていません',
        noData: 'テストレッスンのURLを作成するために[作成]ボタンを押してください。',
        remainingTestLesson: 'テストレッスン可能回数',
        usedLesson:
          '全てのテストレッスンが終了しました。さらにテストレッスンが必要な場合は営業担当へご連絡下さい。',
        notAllowed: 'レッスンの作成はできません。ビズメイツの営業担当者にお問い合わせください。',
        checkValidCredentials: 'メールとパスワードが有効かご確認ください。',
        unexpectedError: '予期せぬエラーが発生しました。'
      },
      dialog: {
        warning: '注意',
        buttons: {
          confirm: '確認'
        }
      }
    },
    recordDialog: {
      title: '注意',
      message:
        '録画を開始する場合、ブラウザから確認されるポップアップ内で、<br>記録したい画面を選択し共有を許可する必要があります。<br>なお、実際に画面がトレーナーに共有されるものではありません。',
      checkLabel: '次回からはこのメッセージを表示しない',
      buttons: {
        confirm: '続ける',
        cancel: 'キャンセル'
      }
    },
    sideMenu: {
      title: '設定',
      deviceTitle: '音声とビデオの設定',
      colorTitle: '背景カラー',
      otherTitle: '他の',
      faqTitle: 'よくあるご質問',
      virtualBgTitle: 'ビデオ背景',
      color: {
        light: 'ライトグレー',
        dark: 'ブラック'
      },
      virtualBg: {
        none: '背景なし',
        blur: '背景ぼかし'
      },
      langSettings: {
        title: '言語',
        ja: '日本語',
        en: '英語'
      }
    },
    videoLabel: {
      button: 'ビデオを引き続きご覧になりたい場合は',
      link: 'こちら →'
    },
    trainerTag: {
      hasBeenTag: '“{0}” がタグ付けされました。',
      edited: '編集済み'
    },
    htmlMaterial: {
      title: '{0} 教材',
      print: '教材印刷',
      download: 'PDFダウンロード',
      downloadHtml: 'HTMLダウンロード'
    },
    pdfNotification: '現在、教材の一部機能が使用できません',
    screenRecordNotification: {
      [ACCOUNT_TYPE.trainer] : '受講生がレッスンに再入室しました。録画を再開するため、画面を再選択してください。',
      [ACCOUNT_TYPE.student] : 'トレーナーがレッスンに復帰しました。録画を再開するには、画面を再選択してください。',
    },
    screenShareAudioNotification: {
      title: '音声共有がご利用いただけません',
      message: 'お使いのブラウザでは、音声共有機能がサポートされていません。Google Chrome、Microsoft Edgeの最新版をご利用いただくことをお勧めします。',
    },
    deviceNotification: {
      success: 'デバイスが{0}に変更されました。',
      successAndroid: 'デバイスが{0}に変更されました\n\nスピーカーから Bluetooth に切り替えると、Android で問題が発生する可能性があります。ページを更新してください。',
      warning: 'デバイスに何か問題があるようです。もう一度お試し頂くか、別のデバイスをお使い下さい。',
      info: 'デバイスリストが更新されました。メニューからデバイスを管理できます。'
    },
    systemDefault: 'システムのデフォルト',
    deviceNotificationBeforeLesson: 'レッスン前のこの画面ではデバイスを変更またはテストすることができません。',
    deviceSelectionDisabled: 'スマートフォンではデバイスを選択できません。',
    dontShowDeviceNotificationAgainMessage: 'デバイスの通知を再表示しない。',
    modal: {
      close: 'ウィンドウを閉じる'
    },
    autoplayNotif: {
      title: 'オーディオ再生が中断されました',
      content: '[再生する]ボタンを押して、<br/> オーディオ再生を再開してください。'
    },
    postAssessmentPromotion: {
      title: {
        bizmates: 'もっと自由に話せる自分に会いに行こう'
      },
      ctaButton: {
        bizmates: 'このプランに申し込む'
      },
      royalBenefitsNote: {
        bizmates: '※ロイヤル特典の対象となる場合があります。『申し込む』ボタンを押した後の次画面でご確認ください。'
      },
      footerNote: {
        title: {
          bizmates: '無料体験レッスンを、難しいと感じた方へ'
        },
        content: {
          bizmates: 'ビズメイツでは、レベルに合わせた教材とトレーナーを用意しています。 実は、ビズメイツを始める方の約半分が英語初心者。最初は「難しい」と感じるところから、みなさん始めています。'
        }
      }
    },
    chatSupportText: "サポート翻訳",
    messageSendText: "日本語でメッセージを選ぶと翻訳された英語メッセージを送ることができます。",
    clickHereText: "確認する",
  }
};
